import React from "react";

export default function HtmlCenterContainer({ children = "" }) {
  return (
    <div
      className={`h-screen w-full flex flex-col justify-center items-stretch scroll-thumb bg-back`}
    >
      {children}
    </div>
  );
}
